import {
  Directive,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  Renderer2,
  SimpleChanges,
} from '@angular/core';

@Directive({
    selector: '[cyData]',
    standalone: false
})
export class CyDataDirective {
  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @Input('cyData') set cyDataAttr(value: string) {
    if (value) {
      this.renderer.setAttribute(this.el.nativeElement, 'data-cy', value);
    }
  }
}
